import { FaRegNewspaper } from "react-icons/fa";
import { FiBarChart2, FiTarget } from "react-icons/fi";
import {
  GiCalculator,
  GiPayMoney,
  GiReceiveMoney,
  GiSwordman,
  GiSwordsEmblem,
  GiTakeMyMoney,
} from "react-icons/gi";
import {
  MdAccountBalance,
  MdAreaChart,
  MdMultilineChart,
  MdOutlineAttachMoney,
  MdOutlineMultilineChart,
  MdOutlinePriceChange,
  MdOutlineSell,
  MdStackedLineChart,
  MdWaterfallChart,
  MdWebStories,
} from "react-icons/md";
import { BiCalendar, BiDoughnutChart, BiHealth } from "react-icons/bi";
import {
  RiBarChartGroupedLine,
  RiFileChartLine,
  RiFileListLine,
  RiMentalHealthFill,
  RiTeamLine,
} from "react-icons/ri";

import { projectPrimaryColor } from "../../../../generalConfigs";
import { BsStoplights } from "react-icons/bs";
import { AiOutlineAlert } from "react-icons/ai";

export type AnalyzeCategory = {
  title: string;
  icon: any;
};
const defaultIconSize = 32;

const sharedCategories: AnalyzeCategory[] = [
  {
    title: "Analisando notícias",
    icon: <FaRegNewspaper size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Sentimento de outros investidores",
    icon: (
      <RiMentalHealthFill size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Montando stories",
    icon: <MdWebStories size={defaultIconSize} color={projectPrimaryColor} />,
  },
];

export const stockCategories: AnalyzeCategory[] = [
  {
    title: "Analisando balanço patrimonial",
    icon: (
      <MdAccountBalance size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Analisando lucros da empresa",
    icon: <GiReceiveMoney size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando preço médio",
    icon: (
      <MdOutlinePriceChange
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Avaliando P/VPA",
    icon: <GiCalculator size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando Dividend Yield",
    icon: <GiPayMoney size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando liquidez",
    icon: <MdOutlineSell size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando EV/EBITDA",
    icon: <GiCalculator size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando projeções do setor",
    icon: <FiTarget size={defaultIconSize} color={projectPrimaryColor} />,
  },
  ...sharedCategories,
  {
    title: "Avaliando Preço/Lucro (P/L)",
    icon: <GiCalculator size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando histórico gráfico",
    icon: (
      <MdStackedLineChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Avaliando concorrência",
    icon: <GiSwordman size={defaultIconSize} color={projectPrimaryColor} />,
  },

  {
    title: "Avaliando saúde da empresa",
    icon: <BiHealth size={defaultIconSize} color={projectPrimaryColor} />,
  },
];

export const forexCategories: AnalyzeCategory[] = [
  {
    title: "Analisando calendário econômico",
    icon: <BiCalendar size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando Indicadores técnicos",
    icon: (
      <MdMultilineChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Avaliando preço médio",
    icon: (
      <MdOutlineAttachMoney
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Análise técnica",
    icon: (
      <MdStackedLineChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Análise fundamental dos eventos",
    icon: (
      <RiFileChartLine size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Avaliando tendências",
    icon: (
      <RiBarChartGroupedLine
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Analisando suporte e resistência",
    icon: (
      <MdOutlineMultilineChart
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Analisando médias moveis",
    icon: <MdAreaChart size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando histórico de preço",
    icon: <RiFileListLine size={defaultIconSize} color={projectPrimaryColor} />,
  },
  ...sharedCategories,
];

export const criptoCategories: AnalyzeCategory[] = [
  {
    title: "Analisando volume de negociações",
    icon: <FiBarChart2 size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando Tokenomics",
    icon: (
      <BiDoughnutChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Avaliando preço médio",
    icon: (
      <MdOutlineAttachMoney
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Avaliando possibilidade Rug Pull",
    icon: <GiSwordsEmblem size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando projeções do mercado",
    icon: <FiTarget size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando entrada/saída de corretoras",
    icon: <GiTakeMyMoney size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Avaliando volatilidade",
    icon: (
      <MdWaterfallChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Analisando nível de risco",
    icon: <BsStoplights size={defaultIconSize} color={projectPrimaryColor} />,
  },
  ...sharedCategories,

  {
    title: "Avaliando Indicadores técnicos",
    icon: (
      <MdMultilineChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Análise fundamental",
    icon: (
      <RiFileChartLine size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Identificando shitcoins",
    icon: <AiOutlineAlert size={defaultIconSize} color={projectPrimaryColor} />,
  },
];

export const genericCategories: AnalyzeCategory[] = [
  {
    title: "Avaliando preço médio",
    icon: (
      <MdOutlineAttachMoney
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Análise técnica",
    icon: (
      <MdStackedLineChart size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Analisando liquidez",
    icon: <MdOutlineSell size={defaultIconSize} color={projectPrimaryColor} />,
  },

  {
    title: "Análise fundamentalista",
    icon: (
      <RiFileChartLine size={defaultIconSize} color={projectPrimaryColor} />
    ),
  },
  {
    title: "Analisando nível de risco",
    icon: <BsStoplights size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando projeções do mercado",
    icon: <FiTarget size={defaultIconSize} color={projectPrimaryColor} />,
  },
  ...sharedCategories,
  {
    title: "Analisando volume de negociações",
    icon: <FiBarChart2 size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando histórico de preço",
    icon: <RiFileListLine size={defaultIconSize} color={projectPrimaryColor} />,
  },
  {
    title: "Analisando tendência",
    icon: (
      <RiBarChartGroupedLine
        size={defaultIconSize}
        color={projectPrimaryColor}
      />
    ),
  },
  {
    title: "Analisando governança",
    icon: <RiTeamLine size={defaultIconSize} color={projectPrimaryColor} />,
  },
];
